import script from "./ProdutoRotuloSolicitacaoPage_29.vue?vue&type=script&setup=true&lang=js"
export * from "./ProdutoRotuloSolicitacaoPage_29.vue?vue&type=script&setup=true&lang=js"

import "./ProdutoRotuloSolicitacaoPage_29.vue?vue&type=style&index=0&id=ea167bf8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea167bf8"]])

export default __exports__